<slick-drop-down *ngIf="!isMobile"
				 [items]="items"
				 [ngModel]="value"
				 (ngModelChange)="setValue($event)"
				 [disabled]="disabled"
				 [placeholder]="placeholder"></slick-drop-down>

<ng-container *ngIf="isMobile">
	<button type="button" class="ac-select" [class.is-empty]="!selectedText" [disabled]="disabled" (click)="open()">
		<span class="ac-select-text">{{ selectedText || placeholder }}</span>
		<i class="bi bi-chevron-down"></i>
	</button>

	<!-- Plain markup rather than an Ionic overlay, same as the picture pickers, so the spec sheet stays
	     one component on both surfaces -->
	<div class="ac-options-backdrop" *ngIf="showOptions" (click)="close()">
		<div class="ac-options" role="listbox" [attr.aria-label]="label" (click)="$event.stopPropagation()">
			<div class="ac-options-header">
				<span>{{ label }}</span>
				<button type="button" class="ac-options-close" aria-label="Close" (click)="close()">
					<i class="bi bi-x-lg"></i>
				</button>
			</div>
			<div class="ac-options-list">
				<button type="button"
						class="ac-option"
						role="option"
						*ngFor="let item of items"
						[class.selected]="item.id === value"
						[attr.aria-selected]="item.id === value"
						(click)="pick(item)">
					<span>{{ item.text }}</span>
					<i *ngIf="item.id === value" class="bi bi-check-lg"></i>
				</button>
				<button type="button" class="ac-option ac-option-clear" *ngIf="selectedText" (click)="pick(null)">
					Clear
				</button>
			</div>
		</div>
	</div>
</ng-container>
